// ============================================
// ACHH WEBSITE CONTENT
// Edit all text content, images, and data here
// ============================================

const siteContent = {
  // ============================================
  // SITE CONFIGURATION
  // ============================================
  config: {
    siteName: "ACHH",
    siteFullName: "The African Cultural Heritage Hub Inc",
    logoUrl: "/images/logo.png",
    showFullName: true,
    paypalEmail: "websesame@gmail.com", // UPDATE THIS with your PayPal email
    contactEmail: "info@africanculturehub.org",
    contactPhone: "(470) 979-4694",
  },

  // ============================================
  // NAVIGATION MENU
  // ============================================
  navigation: {
    links: [
      { label: "Home", href: "#home" },
      { label: "About", href: "#about" },
      { label: "Projects", href: "#projects" },
      { label: "Heritage Wall", href: "http://africanculturehub.org/wall/", external: true },
      { label: "Volunteer", href: "#volunteer" },
      { label: "Contact", href: "#contact" },
      // This last link is rendered as a highlighted button, not a plain text link
      { label: "Donate", href: "#donate", isButton: true },
    ],
  },

  // ============================================
  // HERO SECTION
  // ============================================
  hero: {
    title: {
      line1: "African Cultural",
      line2: "Heritage Hub",
    },
    subtitle: "Preserving the Past • Celebrating the Present • Inspiring the Future",
    buttons: {
      primary: {
        text: "Explore Our Projects",
        link: "#projects",
      },
      secondary: {
        text: "Support Our Mission",
        link: "#donate",
      },
    },
  },

  // ============================================
  // ABOUT SECTION
  // ============================================
  about: {
    title: "Our Mission",
    paragraphs: [
      "Preserving African Cultural Heritage for a Global Generation",
      "The African Cultural Heritage Hub Inc. (ACHH) is a nonprofit organization dedicated to preserving and promoting African cultural heritage through storytelling, traditional arts, music, dance, documentaries, and youth programs. We provide cultural education experiences that connect African folklore, history, and artistic traditions with communities across the diaspora and beyond.",
      "Through workshops, heritage tours, publications, and community events, ACHH empowers young people and families to engage deeply with Africa's rich cultural legacy. Join us in sustaining African storytelling, safeguarding ancestral knowledge, and ensuring African traditions remain vibrant, accessible, and celebrated worldwide.",
    ],
  },

  // ============================================
  // FOUNDER'S STORY SECTION
  // ============================================
  founderStory: {
    title: "Our Founder's Story",
    eyebrow: "From the Director",
    name: "Rotimi Ogunjobi",
    role: "Founder & Executive Director",
    photoUrl: "https://cdn.doodleipsum.com/700x875/avatar-2?bg=DAA520&i=founder-photo", // ⭐ REPLACE with an actual photo of the founder
    paragraphs: [
      "Rotimi Ogunjobi is a Nigerian-born author, folklorist, and media producer whose work spans African folktales, literary fiction, documentary film, and animated storytelling. His books include The Bata Dancer, The Dreamers — longlisted for the Commonwealth Book Prize — I Dead, and Somber City, alongside a growing catalog of more than 50 titles that carry African oral tradition to contemporary readers.",
      "He founded The African Cultural Heritage Hub out of a conviction that Africa's oral traditions deserve the same institutional permanence as its written history. What began as personal storytelling has grown into a nonprofit channeling decades of research and craft into documentary film, animated series, children's literature, and educational publishing — work that now reaches classrooms, public libraries, and streaming platforms around the world.",
    ],
    // ⭐ REPLACE this with a short, personal quote from Rotimi about why this work matters to him
    quote: "Every folktale carries a community's memory. My work is making sure that memory has somewhere permanent to live.",
  },

  // ============================================
  // IMPACT SECTION
  // ============================================
  impact: {
    title: "Our Impact",
    subtitle: "African storytelling, measured in reach",
    statement: "Every folktale we publish, every film we distribute, and every workshop we host carries African heritage a little further than it's traveled before.",
    stats: [
      {
        number: "35",
        label: "Episodes in our animated folktale anthology",
      },
      {
        number: "500,000+",
        label: "Institutions reached through our film & documentary distribution",
      },
      {
        number: "50+",
        label: "Published titles preserving African oral tradition",
      },
      {
        number: "5,000+",
        label: "People reached through workshops & community programs annually",
      },
      {
        number: "3+",
        label: "Years of active cultural production",
      },
      {
        number: "501(c)(3)",
        label: "Registered nonprofit in the State of Georgia, USA",
      },
    ],
  },

  // ============================================
  // CURRENT PROJECTS SECTION
  // ============================================
  projects: {
    title: "Current Projects",
    subtitle: "What we're producing, distributing, and building right now",
    items: [
      {
        icon: "🎨",
        accent: "ochre",
        category: "Traditional Arts & Crafts",
        status: "Ongoing Programming",
        description: "Hands-on workshops in traditional crafts, drumming, and dance led by master practitioners, keeping ancestral techniques alive for new generations of artists and audiences.",
      },
      {
        icon: "🎬",
        accent: "terracotta",
        category: "Documentary & Films",
        status: "Active Distribution",
        description: "Our documentary catalog — including the Legends & Legacy series and Voices from the Continent — explores African oral tradition on screen, distributed to schools and libraries nationwide. A short-film adaptation of the novella I Dead is currently in development.",
      },
      {
        icon: "📺",
        accent: "forest-green",
        category: "Children's TV & Book Series",
        status: "In Development",
        description: "KÒBÒ & THE STORY ROAD, our animated series in development with fiscal sponsorship through Fractured Atlas, brings African folktales to a new generation of viewers. It joins Magic Story Cloud, our 35-title illustrated children's book series.",
      },
      {
        icon: "📚",
        accent: "deep-brown",
        category: "Publication & Literacy",
        status: "Active Catalog",
        description: "A growing library of folklore, fiction, and educational texts — from When the Sun Sleeps to our African Folktales and Storytelling course — designed to keep African storytelling traditions accessible in print, audio, and the classroom.",
      },
    ],
  },

  // ============================================
  // PARTNERSHIPS SECTION
  // ============================================
  partnerships: {
    title: "Our Partnerships",
    subtitle: "Organizations helping us bring African heritage further",
    items: [
      {
        name: "Films Media Group / Infobase Learning",
        role: "Educational Distribution Partner",
        description: "Brings our documentary and animated catalog to 500,000+ schools, colleges, and public libraries nationwide.",
      },
      {
        name: "Fractured Atlas",
        role: "Fiscal Sponsor",
        description: "Provides nonprofit fiscal sponsorship for our animated series currently in development.",
      },
      {
        name: "OverDrive",
        role: "Library Distribution Partner",
        description: "Makes our book catalog available to public library patrons nationwide.",
      },
      {
        name: "Draft2Digital",
        role: "Publishing & Distribution Partner",
        description: "Powers ebook and print distribution of our catalog across major retailers.",
      },
    ],
  },

  // ============================================
  // VOLUNTEER SECTION
  // ============================================
  volunteer: {
    title: "Volunteer With Us",
    subtitle: "Share your time, skills, or expertise to help preserve and celebrate African cultural heritage",
    waysToHelp: [
      "Workshop & event support — help facilitate cultural workshops, heritage tours, and community events",
      "Content & storytelling — contribute writing, translation, narration, or research to our publications and films",
      "Technical & digital — support our website, digital archives, and social media presence",
      "Outreach & partnerships — help connect ACHH with schools, libraries, and community organizations",
    ],
    interestOptions: [
      "Workshop & Event Support",
      "Content & Storytelling",
      "Technical & Digital",
      "Outreach & Partnerships",
      "Other",
    ],
    // ⭐ REPLACE the form's submission handling — e.g. add a Formspree endpoint or a backend handler
    submitText: "Submit Volunteer Interest",
  },

  // ============================================
  // CONTACT SECTION
  // ============================================
  contact: {
    title: "Get in Touch",
    subtitle: "Have questions? Want to get involved? We'd love to hear from you!",
    email: "info@africanculturehub.org",
    phone: "(470) 979-4694",
    address: "Atlanta, GA 30324",
  },

  // ============================================
  // DONATE SECTION
  // ============================================
  donate: {
    title: "Support Our Mission",
    subtitle: "Your contribution helps preserve and celebrate African cultural heritage",
    infoTitle: "Why Your Support Matters",
    benefits: [
      "Fund educational programs and workshops for youth and communities",
      "Support artists, musicians, and cultural practitioners",
      "Preserve traditional knowledge and oral histories",
      "Create accessible cultural resources and publications",
    ],
    amountTitle: "Select an Amount",
    // Each amount now carries a short, illustrative description of its impact
    amounts: [
      { value: "25", label: "$25", impact: "Could help supply materials for one workshop participant" },
      { value: "50", label: "$50", impact: "Could help sponsor a child's access to our folktale series for a year" },
      { value: "100", label: "$100", impact: "Could help fund a community storytelling event" },
      { value: "250", label: "$250", impact: "Could help support production costs for a documentary segment" },
      { value: "500", label: "$500", impact: "Could help fund a full workshop series for a youth cohort" },
      { value: "", label: "Custom", impact: "Choose the amount that's right for you" },
    ],
    buttonText: "Donate Now via PayPal",
    taxNote: "The African Cultural Heritage Hub Inc. is a 501(c)(3) nonprofit organization. Your donation through this website is tax-deductible. ",
  },

  // ============================================
  // FOOTER
  // ============================================
  footer: {
    sections: [
      {
        title: "The African Cultural Heritage Hub Inc",
        content: "Preserving traditions, inspiring futures.",
      },
      {
        title: "Quick Links",
        links: [
          { text: "About Us", href: "#about" },
          { text: "Impact", href: "#impact" },
          { text: "Projects", href: "#projects" },
          { text: "Partnerships", href: "#partnerships" },
          { text: "Heritage Wall", href: "http://africanculturehub.org/wall/", external: true },
          { text: "Volunteer", href: "#volunteer" },
          { text: "Donate", href: "#donate" },
        ],
      },
      {
        title: "Contact",
        lines: [
          "Email: info@africanculturehub.org",
          "Phone: (470) 979-4694",
          "Director: Rotimi Ogunjobi",
        ],
      },
    ],
    copyright: "© 2026 African Cultural Heritage Hub Inc. is a 501(c)(3) nonprofit organization incorporated as a charitable organization in the state of Georgia, USA. Control Number : 26115989 . All rights reserved.",
  },
};

export default siteContent;
